// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "@charset \"UTF-8\";\n.super-sview-class[data-v-e1fa93b4] {\n  width: 100%;\n  height: 100%;\n  /* 现在父容器是 flex 了，这里就能被拉伸 */\n  /* 真正滚动交给内部列表/ChatView */\n}", ""]);
// Exports
module.exports = exports;
